import classNames from 'classnames';

import { ContentLayoutInterface } from '../../interfaces/layout';

import { styles } from './styles';

const ContentLayout = ({
  children,
  hasBackground = false,
  withPaddingDefault,
  fullContainer,
  className,
  isDisabled= false
}: ContentLayoutInterface) => {
  const { classes } = styles();

  return (
    <div
      className={classNames(
        classes.container,
        {
          [classes.hasBackground]: hasBackground,
          [classes.withPaddingDefault]: withPaddingDefault,
          [classes.fullContainer]: fullContainer,
          [classes.isDisabled]: isDisabled,
          
        },
        className
      )}>
      {children}
    </div>
  );
};

export default ContentLayout;
